import { api, formatApiErrorDetail } from "./api";

/**
 * Nexa-Core chat API client. Mirrors the audit.js shape so error handling
 * stays uniform across the app.
 *
 * @param {Array<{role:"user"|"assistant",content:string}>} messages
 * @param {"en"|"es"|"hi"} language
 */
export async function sendChat(messages, language) {
  try {
    const { data } = await api.post("/nexacore/chat", { messages, language });
    return { ok: true, data };
  } catch (e) {
    return {
      ok: false,
      status: e.response?.status,
      body: e.response?.data,
      message:
        formatApiErrorDetail(e.response?.data?.detail) || e.message,
    };
  }
}
